module.exports = __webpack_public_path__ + "static/media/25_blanco.083c9620.svg";